import React from "react";
import { Box, Button, Stack } from "@mui/material";
import { HEADER_HEIGHT, HEADER_OPTIONS } from "../../../../utils/ui.constants";
import IConButtonApp from "../../IconButtonApp/IConButtonApp";
import UserSetting from "./UserSetting";
import GlobalSearch from "./GlobalSearch";
import { LuBellRing, LuMaximize, LuMenu, LuStore } from "react-icons/lu";
import Logo from "./Logo";
import HeaderMobile from "./HeaderMobile";
import SelectApiInput from "../../input/SelectApiInput";
import { useDispatch, useSelector } from "react-redux";
import { updateCurrentStore } from "../../../../redux/reducers/config.reducer";

interface IHeader {
  useMenu?: boolean;
  useSearch?: boolean;
  toggleSideBar?: () => void;
}

function Header({ useMenu = true, useSearch = true, toggleSideBar }: IHeader) {
  const { currentStore } = useSelector((state: any) => state.config);
  const dispatch = useDispatch();

  const openFullScreen = () => {
    const el = document.documentElement;
    if (!el) return;
    if (el.requestFullscreen) {
      el.requestFullscreen();
    }
  };

  return (
    <Box
      component="header"
      sx={{
        width: "100%",
        height: HEADER_HEIGHT,
        py: 1,
        backgroundColor: "background.paper",
      }}
    >
      {/* Header pc */}
      <Stack
        sx={{
          display: { xs: "none", md: "flex" },
          width: "100%",
          height: "100%",
        }}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ flex: 1, pl: 2 }}
        >
          <Logo />
          {useMenu && (
            <IConButtonApp onClick={toggleSideBar}>
              <LuMenu size={20} />
            </IConButtonApp>
          )}
        </Stack>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ width: "calc(100% - 260px)", height: "100%", px: 2 }}
        >
          <Stack direction="row" alignItems="center" sx={{ flex: 1 }}>
            <Box sx={{ width: "60%", maxWidth: "430px" }}>
              {useSearch && <GlobalSearch />}
            </Box>
          </Stack>
          <Stack direction="row" alignItems="center" gap={2}>
            <SelectApiInput
              forceOpenSelect={!currentStore}
              selectTitle="Chọn chi nhánh"
              placeholderSearch="Tìm theo mã, tên chi nhánh"
              wrapperSx={{ width: "120px", height: "42px" }}
              apiCode="dmkho"
              searchFields={["ma_kho", "ten_kho"]}
              getOptionLabel={(option) => option.ten_kho}
              checkEqual={(value, option) => value?.ma_kho === option?.ma_kho}
              value={currentStore}
              onChange={(val) => dispatch(updateCurrentStore(val))}
              renderDisplay={({ value, onClick }) => {
                return (
                  <Button
                    id="display-store"
                    size="small"
                    variant="contained"
                    onClick={onClick}
                    sx={{
                      backgroundColor: "background.default",
                      color: "text.primary",
                      textTransform: "none",
                      fontWeight: 400,
                      boxShadow: "none",
                      height: "34px",
                      "&:hover": {
                        boxShadow: "none",
                      },
                    }}
                    startIcon={<LuStore size={16} />}
                  >
                    {value?.ten_kho || "Chọn chi nhánh"}
                  </Button>
                );
              }}
            />
            <IConButtonApp>
              <LuBellRing size={20} />
            </IConButtonApp>
            <IConButtonApp
              onClick={openFullScreen}
              sx={{
                backgroundColor: "primary.600",
                color: "primary.main",
                "&:hover": {
                  backgroundColor: "primary.main",
                  color: "common.white",
                },
              }}
            >
              <LuMaximize size={20} />
            </IConButtonApp>
            <UserSetting options={HEADER_OPTIONS} />
          </Stack>
        </Stack>
      </Stack>
      {/* Header pc end */}
      {/* Header mobile */}
      <HeaderMobile />
      {/* Header mobile end */}
    </Box>
  );
}

export default Header;
